import { render, staticRenderFns } from "./Treeselect.vue?vue&type=template&id=2efad400&"
import script from "./Treeselect.vue?vue&type=script&lang=js&"
export * from "./Treeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports